module.exports = __webpack_public_path__ + "img/CAL-UHF-Zubehörkoffer_white_shadow_Var3.a444446e.png";